import BottomMobileInterstitial from './BottomMobileInterstitial';

export default BottomMobileInterstitial;
